<template>
  <div class="step" :class="{ active: request }">
    <BaseIcon glyph="schedule" width="32px" class="mb-s" />
    <p class="mb-xs fw-700">Шаг 4</p>
    <p class="step-description">Подать заявку в&nbsp;выбранный трек</p>
    <div v-if="user" class="info-block">
      <StepInfo class="mt-s" :is-done="!!request" />
      <StepInfo
        class="mt-s"
        :info-text="request ? 'Вы зарегистрированы' : 'У вас нет заявки'"
        :is-success="!!request"
      />
      <BaseButton
        tag="a"
        :href="request ? requestLink : '#tracks'"
        :target="request ? '_blank' : '_self'"
        :disabled="
          !(
            organizations.length &&
            !!selectedOrganization &&
            !!selectedPlatform
          )
        "
        :rel="request ? 'noopener noreferrer' : ''"
        class="mt-s"
        size="xs"
        shape="square"
        >{{ request ? "Перейти к заявке" : "Создать заявку" }}</BaseButton
      >
    </div>
  </div>
</template>

<script>
import StepInfo from "@/components/StepInfo";

export default {
  name: "RequestStep",
  props: {
    request: Object,
  },
  components: {
    StepInfo,
  },
  computed: {
    organizations() {
      return this.$store.state.requestPreparing.organizations;
    },
    user() {
      return this.$store.state.user.user;
    },
    selectedOrganization() {
      return this.$store.state.requestPreparing.selectedOrganization;
    },
    selectedPlatform() {
      return this.$store.state.requestPreparing.selectedPlatform;
    },
    requestLink() {
      if (!this.request) return;
      return `${process.env.VUE_APP_TALENT_HOST}/events/requests/${this.request.id}`;
    },
  },
};
</script>

<style lang="less" scoped>
.step {
  padding: 20px;
  width: 100%;
  border-radius: @border-radius-xs;
  border: 1px solid @blue-color;
  background-color: #fff;
  color: @primary-color;
  display: flex;
  flex-direction: column;

  &-description {
    color: @base-color;
  }

  &.active {
    background-color: @background-blue;
    border-color: @info-color;
    color: @base-color;
  }
}

.info-block {
  margin-top: auto;
}

@media (max-width: @screen-xs-max) {
  .step {
    max-width: 100%;
  }
}
</style>
